module.exports = __webpack_public_path__ + "static/media/edit-action.3b9fe200.svg";